import { Text } from '@lmc/ui-kit/src/general'
import type { ComponentProps, FC } from 'react'
import styled from 'styled-components'

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.palette.darkpurple};
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  opacity: 0.7;
  max-width: 800px;
  margin-top: 10px;
  margin-bottom: 20px;
`

export const OnboardingText: FC<ComponentProps<typeof Text>> = (props) => (
  <StyledText {...props} />
)
